import { Clock4 } from 'lucide-react';

const ProjectBlobClient = (props) => {
    
    var local = new Date(props.project.due_date);
    var offset = local.getTimezoneOffset();
    var due_date = new Date(local.getTime() + offset * 60000);

    function convertCurrencyToDouble(currency, locale = 'en-US', currencyType = 'USD') {
        // Creating a NumberFormat object with specified locale and currency
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyType,
            currencyDisplay: 'symbol'
        });
    
        // Formatting the currency to remove any non-numeric characters except for decimal point
        const normalizedCurrency = currency.replace(/[^\d.-]+/g, "");
    
        // Converting the normalized string to a double value using Number constructor
        const doubleValue = Number(normalizedCurrency);
    
        // Returning the double value
        return doubleValue;

    }

    const fee = convertCurrencyToDouble(props.project.fee)
    const paid = convertCurrencyToDouble(props.project.paid)

    let statusColor = (function () {
        switch (props.project.status){
            case "Not Started":
                return "not_started"
                break;
            case "Awaiting Assets":
                return "assets"
                break;
            case "In Progress":
                return "wip"
                break;
            case "Awaiting Feedback":
                return "feedback"
                break;
            case "Revising":
                return "revising"
                break;
            case "Mastering":
                return "mastering"
                break;
            case "Delivering":
                return "delivering"
                break;
            case "Complete":
                return "complete"
                break;
            default:
                return ""
        }
    })();

    return (

        <div className="projectBlobNarrow gradientWhite rounded-lg px-5 py-2 text-black hoverLeft">
            {/* <div className="flex flex-row items-center"> */}
                <div className="flex flex-col ">
                    <div className="grid grid-cols-6 text-xs items-center">
                        <h4 className="text-black col-span-4 overflow-hidden text-nowrap text-ellipsis">
                            {props.project.title}
                        </h4>
                        <div className="text-[9px] font-semibold text-nowrap text-[#555] col-span-2 align-right">
                            &nbsp; Due  {due_date.toDateString()}
                        </div>
                    </div>
                    <div className="flex flex-row gap-3 text-[9px] font-esmibold">
                        <div className={statusColor+ " justify-center items-center flex px-1 py-1 rounded-lg uppercase"}>
                            {props.project.status}
                        </div>
                        {paid>=fee ? 
                            <div className="w-fit bg-[#007100] text-white uppercase font-semibold py-1 rounded-lg px-2" id=""> 
                                Paid
                            </div>
                            : 
                            <div className='col-span-1'></div> 
                        }
                    </div>
                </div>

            {/* </div> */}
        </div>
    )
}

export default ProjectBlobClient